import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { client, errorValidation } from "./service.js";
import { reactLocalStorage } from "reactjs-localstorage";

export async function login({
    username, password
}) {
    try {
        let response = await client.post(`${adminUrl}/login`, {
            username, password
        });

        if (response.data.statusCode !== 200) {
          console.log("Login Business Error:", response.data);
            throw response.data
        }

        console.log("Login Business Error: berhasil");

        return { data: response.data };
    } catch (e) {
    console.log("Detail Error:", e); 
    
    if (e.response) {
        // Log spesifik untuk error 404 dari server
        console.error("Data dari Server:", e.response.data);
        console.error("Status Code:", e.response.status);
    }
        return errorValidation(e)
    }
}

export async function logout() {
    try {
        // let response = await client.get(`${adminUrl}/logout`);
        localStorage.clear()
        reactLocalStorage.clear()
        window.location.href = "/login"

        // if (response.data.statusCode !== 200) {
        //     throw response.data
        // }

        // return { data: response.data };
        return { data: null };
    } catch (e) {
        return errorValidation(e)
    }
}

export const checkCredential = async function (username) {
  try {
    let response = await client.post(`/check-credential`, {
      username: username
    });
    if (response.data.statusCode !== 200) { throw response.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}

export const sendOTPService = async function (body) {
  try {
    let response = await client.post('/send-otp', {
      username: body.username || "",
      resend: body.resend || "",
      resendWithDevice: body.resendWithDevice || ""
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode };
    return errorValidation(e)
  }
}

export const checkOTPService = async function (body) {
  try {
    let response = await client.post('/check-otp', {
      username: body.username || "",
      OTP: body.OTP
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode };
    return errorValidation(e)
  }
}

export const setCredential = async function (username, confirmPassword) {
  try {
    let response = await client.post(`/set-credential`, {
      username: username,
      password: confirmPassword
    });
    if (response.data.statusCode !== 200) { throw response.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    return errorValidation(e)
  }
}